// extracted by mini-css-extract-plugin
var _1 = "InvitationView-module__loadingWrapper--ReIPH";
export { _1 as "loadingWrapper" }
